<script setup lang="ts">

import { onMounted, ref } from 'vue';
import type { Animation } from '../Types/Animation';

type Props = { animation?: Animation, delay?: number, duration?: number }

const { animation = 'fade', delay = 300, duration = 300 } = defineProps<Props>();
const target = ref<Element>();
const animate = ref<boolean>(false);

const observer = new IntersectionObserver( ([entry]) => 
{ 

    if( entry.isIntersecting == false ) 
    {
        animate.value = false;
        return;
    }

    // start the animation and disconnect the observer
    animate.value = true
    observer.disconnect();

}, { threshold: 0.5 } );

onMounted( () => observer.observe( target.value as Element ) );

</script>

<template>

    <div ref="target">
        <Transition :name="animation" mode="out-in">
            <div v-show="animate"
                 :style="{ transitionDelay: `${delay}ms`, transitionDuration: `${duration}ms` }"
                 :class="{ 
                     'opacity-0 transition-none': animate == false,
                     'grid grid-rows-[0fr] overflow-hidden': animation == 'push-up' && animate == false 
                 }"
                 class="h-full">
                <slot />
            </div>
        </Transition>
    </div>

</template>
